








import { Vue, Component } from "vue-property-decorator"
// @ts-ignore
import zhCN from "ant-design-vue/es/locale/zh_CN"
@Component({})
export default class App extends Vue {
    locale = zhCN

    getPopupContainer(triggerNode: Element) {
        if (triggerNode?.classList.contains("ant-btn-link")) {
            return document.body
        }
        return triggerNode?.parentNode || document.body
    }
}
